import productBigImg from "../../assets/img/productPage1.png";
import productIconImg from "../../assets/img/productPage2.png";


// import { saudiFlag, englishFlag, uaeFlag, omaniFlag, qatarFlag, kuwaitFlag } from "../flags";

// import { stores } from "../flags";

const product = {
    id: Date.now(),
    img: productBigImg,
    icon: productIconImg,
    unitPrice: "60UC - $0.99",
    wishList: false,
    stars: 4,
    rates: "+100",
    points: 90,
    stores: ["sa", "qa", "om", "kw", "ae", "en"],
    balance: [20, 40, 60, 80, 100, 120, 140, 160, 180, 185, 190, 195, 200],
    shipping: true,
    modelNumber: "oc6239",
    ar: {
        head: "بطاقة شحن شدات ببجى",
        headTxt: "بطاقة شحن شدات ببجى",
        desrcribtion:
            "وصف المنتج وصف المنتج وصف المنتج وصف المنتج وصف المنتج وصف المنتج وصف المنتج وصف المنتج وصف المنتج",
        howToUse:
            "<div><ol><li>اذهب للرابط التالى</li><li>سجل الدخول</li></ol></div>"
    },
    en: {
        head: "PUBG UC Cards",
        headTxt: "PUBG UC Cards",
        desrcribtion:
            "product description product description product description product description product description",
        howToUse:
            "<div><ol><li>go to the next link</li><li>login</li></ol></div>"
    }
};

// const options1 = ["20 دولار", "40 دولار", "60 دولار", "80 دولار"];
// const options2 = ["40 دولار", "60 دولار", "80 دولار", "100 دولار"];
// const options3 = ["60 دولار", "80 دولار", "100 دولار", "120 دولار"];
// const options4 = ["80 دولار", "100 دولار", "120 دولار", "140 دولار"];
// const options5 = ["20 دولار"]


// const saudiStore ={
// 	'id':"saStore",
// 	'title':"المتجر السعودى",
// 	'icon':saudiFlag,//url
// 	'options':options1
// }
// const englishStore ={
// 	'id':"enStore",
// 	'title':"المتجر الإنجليزى",
// 	'icon':englishFlag,//url
// 	'options':options2
// }
// const uaeStore ={
// 	'id':"uaeStore",
// 	'title':"المتجر الإماراتى",
// 	'icon':uaeFlag,//url
// 	'options':options3
// }
// const omaniStore ={
// 	'id':"omStore",
// 	'title':"المتجر العمانى",
// 	'icon':omaniFlag,//url
// 	'options':options4
// }
// const kuwitiStore ={
// 	'id':"kuStore",
// 	'title':"المتجر الكويتى",
// 	'icon':kuwaitFlag,//url
// 	'options':options1
// }
// const qatariStore ={
// 	'id':"qaStore",
// 	'title':"المتجر القطرى",
// 	'icon':saudiFlag,//url
// 	'options':options2
// }

// const stores = [saudiStore, uaeStore, kuwitiStore, qatariStore, omaniStore, englishStore]

// const product1 = {
//     id: "product1",
//     title: "بطاقة شحن شدات ببجى",
//     type:['direct_option'],
//     options: options5
// }

// const product2 = {
//     id: "product2",
//     title: "يلا لودو",
//     type:['many_options'],
//     options: options2
// }

// const product3 = {
//     id: "product3",
//     title: "اشتراك بلايستيشن",
//     type:['many_stores'],
//     options: null,
//     stores,

// }

// // const product=
// // {
// // 	'id':int,
// // 	'title':string,
// // 	'type':['direct_option', 'many_options', 'many_stores'],// direct_option: the product has one option only, and has no stores, many_options: the product has many options and has no stores, many_stores: the product has many stores each store has many options
// // 	if(type == direct){
// // 		options:array has one product_option object only,
// // 	}elseif(type == has_options){
// // 		options:array has many product_option object,
// // 	}elseif(type == has_stores){
// // 		stores:array has many store object,
// // 	},
// // 	' ':array of order_form_input objects [],
// // 	'main_image':string,//url
// // 	'images':array,//array of other product imges url
// // 	'rate':rate object,
// // 	'no_rates':int,
// // 	'thumbnail':string,//url
// // 	'marketing_title':string nullable,
// // 	'brief':string nullable,
// // 	'how_to_use':string nullable,
// // 	'description':string nullable,
// // 	'brand':brand object,
// // 	'categories':array of category object,
// // }




export default product;
